import React, {useEffect, useState} from "react";
import API from 'libs/api';

import CMP_STAT from './cmp_stat/cmp_stat';
import CMP_STATSUMMARY from './cmp_statsummary/cmp_statsummary';

import './crd_stat.css';


export default function CRD_STATS({set_currentStatus, var_currentStatus}) {

    //  variable declarations ------------------------------------------------------------------------------------------


    //  data table variables
    const [var_data, set_data] = useState([]);
    const [var_chartData, set_chartData] = useState([]);

    //  data ready variables
    const [var_ready, set_ready] = useState(false);
    const [var_processing, set_processing] = useState('inactive');



    //  event listeners ------------------------------------------------------------------------------------------------

    useEffect(() => {

        populate_stats();

    }, [])



    //  async functions ------------------------------------------------------------------------------------------------

    async function populate_stats() {

        set_data([]);
        set_ready(false);
        set_processing('processing');

        try {
            let results = await API_get_stats();

            let var_chartresults = [];
            var_chartresults.published_complete = results[0].published_complete
            var_chartresults.unpublished = results[0].unpublished
            var_chartresults.published_locationreviewed = results[0].published_locationreviewed

            results[0].published = results[0].published_complete + results[0].published_incomplete;
            results[0].locations_tobereviewed = results[0].locations - results[0].locations_reviewed;
            results[0].activities_tobereviewed = results[0].activities - results[0].activities_reviewed;
            results[0].ages_tobereviewed = results[0].ages - results[0].ages_reviewed;


            //  set data
            set_chartData(var_chartresults);
            set_data(results[0]);

            set_processing('inactive');
            set_ready(true);
        } catch (e) {
            set_processing('error');
        }

    }



    //  API calls ------------------------------------------------------------------------------------------------------

    function API_get_stats(settings) {
        return API.get('admin-providers', '/get-provider-stats');
    }



    //  event functions ------------------------------------------------------------------------------------------------



    // RENDER CONTAINER ================================================================================================

    return (

        <div className='stat__wrapper'>
            <CMP_STATSUMMARY
                var_data={var_chartData}
                var_refresh={populate_stats}
            />

            <div className='stat__wrapper--clickable'>
                <CMP_STAT
                    var_APIstatus='PUBLISHED'
                    var_status='Published'
                    var_providers={var_data.published}
                    var_reviewed={var_data.published - var_data.published_locationreviewed}
                    set_currentStatus={set_currentStatus}
                    var_currentStatus={var_currentStatus}
                />
                <CMP_STAT
                    var_APIstatus='UNPUBLISHED'
                    var_status='Unpublished'
                    var_providers={var_data.unpublished}
                    var_reviewed='0'
                    set_currentStatus={set_currentStatus}
                    var_currentStatus={var_currentStatus}
                />
            </div>

            <div className='stat__wrapper--inner'>
                <CMP_STAT
                    var_APIstatus=''
                    var_status='Locations'
                    var_providers={var_data.locations}
                    var_reviewed={var_data.locations_tobereviewed}
                    set_currentStatus={set_currentStatus}
                    var_currentStatus={var_currentStatus}
                />
                <CMP_STAT
                    var_APIstatus=''
                    var_status='Activities'
                    var_providers={var_data.activities}
                    var_reviewed={var_data.activities_tobereviewed}
                    set_currentStatus={set_currentStatus}
                    var_currentStatus={var_currentStatus}
                />
                <CMP_STAT
                    var_APIstatus=''
                    var_status='Ages'
                    var_providers={var_data.ages}
                    var_reviewed={var_data.ages_tobereviewed}
                    set_currentStatus={set_currentStatus}
                    var_currentStatus={var_currentStatus}
                />
            </div>
        </div>

    )
}